import React from 'react';

export default function CircleXIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path d="M8.00004 14.6663C11.6819 14.6663 14.6667 11.6816 14.6667 7.99967C14.6667 4.31778 11.6819 1.33301 8.00004 1.33301C4.31814 1.33301 1.33337 4.31778 1.33337 7.99967C1.33337 11.6816 4.31814 14.6663 8.00004 14.6663Z" stroke="#FB2C36" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 6L6 10" stroke="#FB2C36" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M6 6L10 10" stroke="#FB2C36" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
